import React from 'react'
import PropTypes from 'prop-types'
import {Form} from '../Form'
import styles from './styles.css'

export default function InlineForm({children, className = '', ...props}) {
  return (
    <Form {...props} className={`${styles.root} ${className}`}>
      {children}
    </Form>
  )
}

InlineForm.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
}
